import { useEffect } from 'react';

import { providersRequest } from 'api/casino';
import DraggableScroll from 'components/DraggableScroll';
import Icon from 'components/Icon/Icon';
import Link from 'components/Link';
import ProviderCard from 'components/ProviderCard';
import { Translation } from 'utils/translations';
import useSliceRequest from 'utils/useSliceRequest';

import styles from './ProviderGamesPage.module.scss';

const requestProps = {
  slice: {
    itemsPerSlice: 14,
  },
};

const MoreProviders = () => {
  const { data, loadMore } = useSliceRequest(providersRequest, requestProps);

  useEffect(() => {
    loadMore();
  }, [loadMore]);

  return (
    <section className={styles['more-providers-wrapper']}>
      <div className={styles['provider-games-info']}>
        <div className={styles['info-wrapper']}>
          <Icon name="providers.bold" />
          <p className={styles.label}>
            <Translation message="more_providers" />
          </p>
        </div>

        <Link className={styles.link} to="~/game-providers">
          <Translation message="view_all" />
        </Link>
      </div>
      <DraggableScroll className={styles['more-providers']}>
        {data.map((provider) => (
          <ProviderCard
            className={styles['wide-provider-card']}
            key={provider.id}
            iconUrl={provider.iconUrl}
            displayedName={provider.displayedName}
          />
        ))}
      </DraggableScroll>
    </section>
  );
};

export default MoreProviders;
